<template>
  <div v-if="showPagination" class="pagination">
    <span v-show="data.current > 1"
      class="first-page"
      @click="goToFirstPage">
      <i class="far fa-chevron-left"></i>
    </span>

    <span v-for="page in data.last"
      :key="page"
      class="item-page"
      :class="getClassName(page)"
      @click="goToPage(page)">
      {{ page }}
    </span>

    <span v-show="data.current < data.last"
      class="last-page"
      @click="goToLastPage">
      <i class="far fa-chevron-right"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ThePagination',

  props: {
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    showPagination() {
      if (!this.data) return false;
      return this.data.last > 1;
    },
  },

  methods: {
    goToPage(page) {
      this.$emit('change', page);
    },

    goToFirstPage() {
      this.$emit('change', 1);
    },

    goToLastPage() {
      this.$emit('change', this.data.last);
    },

    getClassName(page) {
      return (this.data.current === page) ? 'current' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 0 1rem;

    span {
      display: inline-block;
      margin: 0 0.5rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 1.5rem;
      line-height: 2.5rem;
      text-align: center;
      font-weight: 700;
      font-size: 0.875rem;
      color: $grey-medium;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: $white-fade;
        color: $black;
      }

      &.current {
        background-color: $color-primary;
        color: $white;
      }
    }
  }
</style>
